import type { ReactElement } from 'react'

import { HOME_PATH } from '../../../app/routes.ts'

/** Terminal route. Prerendered to `dist/404.html` and served by Netlify verbatim. */
export function NotFoundPage(): ReactElement {
  return (
    <div className="not-found">
      <h1 className="not-found__title">Página não encontrada</h1>
      <p className="not-found__body">
        O endereço solicitado não corresponde a nenhum poema publicado.
      </p>
      <p className="not-found__body">
        <a className="not-found__link" href={HOME_PATH}>
          Ver todos os poemas
        </a>
      </p>
    </div>
  )
}
